export default function Certificaciones() {
  return (
    <div id="wsite-content" className="wsite-elements wsite-not-footer">
      <div className="wsite-section-wrap">
        <div
          className="wsite-section wsite-body-section wsite-background-53"
          style={{
            height: '240px',
            backgroundImage: 'url(/uploads/1/1/9/7/119720466/background-images/1598040425.jpg)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50.00% 48.35%',
            backgroundSize: 'cover',
            backgroundColor: 'transparent',
          }}
        >
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements" />
            </div>
          </div>
        </div>
      </div>

      <div className="wsite-section-wrap">
        <div className="wsite-section wsite-body-section wsite-background-54" style={{ height: 'auto' }}>
          <div className="wsite-section-content">
            <div className="content-wrap container">
              <div className="wsite-section-elements">
                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px' }}>
                    <table className="wsite-multicol-table">
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          <td className="wsite-multicol-col" style={{ width: '33.208255159475%', padding: '0 15px' }}>
                            <div className="paragraph" style={{ textAlign: 'justify' }}>
                              <strong>
                                <font size="5" color="#367d90">
                                  Recycla Chile S.A. dispone de un sistema de gestión ambiental conforme a la Norma ISO 14001:2015
                                </font>
                              </strong>
                            </div>
                          </td>
                          <td className="wsite-multicol-col" style={{ width: '66.791744840525%', padding: '0 15px' }}>
                            <div className="paragraph" style={{ textAlign: 'justify' }}>
                              <font size="3">
                                <strong>Recycla se encuentra genuinamente comprometida con el desarrollo sustentable</strong>, por lo que ha adoptado acciones proactivas para poder contribuir a su desempeño ambiental, más allá de lo requerido por el marco regulatorio, desarrollando la implementación de un instrumento de gestión voluntaria, con miras a un mercado cada vez con mayor exigencias.
                              </font>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="paragraph" style={{ textAlign: 'justify' }}>
                  <font size="3">
                    Desde 2018 posee un robusto Sistema de Gestión Ambiental (SGA), bajo el estándar internacional de la norma ISO 14001:2015, la cual permite un análisis de ciclo de vida (ACV) en toda la cadena productiva, para brindar un servicio integral y ambientalmente seguro en la gestión de residuos.
                  </font>
                </div>

                <div className="wsite-spacer" style={{ height: '30px' }} />

                <div className="wsite-multicol">
                  <div className="wsite-multicol-table-wrap" style={{ margin: '0 -15px' }}>
                    <table className="wsite-multicol-table">
                      <tbody className="wsite-multicol-tbody">
                        <tr className="wsite-multicol-tr">
                          <td className="wsite-multicol-col" style={{ width: '33.333333333333%', padding: '0 15px' }}>
                            <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 10, paddingBottom: 10, marginLeft: 10, marginRight: 10, textAlign: 'center' }}>
                              <a href="/uploads/1/1/9/7/119720466/certificadoga-2018-0205_es_2024-07-09.pdf" target="_blank" rel="noreferrer">
                                <img src="/uploads/1/1/9/7/119720466/captura-de-pantalla-2025-05-06-163602_orig.png" alt="Imagen" style={{ width: 'auto', maxWidth: '100%' }} />
                              </a>
                            </div>
                          </td>
                          <td className="wsite-multicol-col" style={{ width: '33.333333333333%', padding: '0 15px' }}>
                            <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 10, paddingBottom: 10, marginLeft: 10, marginRight: 10, textAlign: 'center' }}>
                              <a href="/uploads/1/1/9/7/119720466/iqnetes-2018-0205_2024-07-09.pdf" target="_blank" rel="noreferrer">
                                <img src="/uploads/1/1/9/7/119720466/captura-de-pantalla-2025-05-06-163653_orig.png" alt="Imagen" style={{ width: 'auto', maxWidth: '100%' }} />
                              </a>
                            </div>
                          </td>
                          <td className="wsite-multicol-col" style={{ width: '33.333333333333%', padding: '0 15px' }}>
                            <div className="wsite-image wsite-image-border-none" style={{ paddingTop: 10, paddingBottom: 10, marginLeft: 10, marginRight: 10, textAlign: 'center' }}>
                              <a href="/uploads/1/1/9/7/119720466/certificadoga-2018-0205_in_2024-07-09.pdf" target="_blank" rel="noreferrer">
                                <img src="/uploads/1/1/9/7/119720466/captura-de-pantalla-2025-05-06-163630_orig.png" alt="Imagen" style={{ width: 'auto', maxWidth: '100%' }} />
                              </a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
